// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1DfYd","col":"styles_col__3tS39"};